import { render, staticRenderFns } from "./directorInfo.vue?vue&type=template&id=70cc1d3a"
import script from "./directorInfo.vue?vue&type=script&lang=js"
export * from "./directorInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports